
export const OPEN_RESA = "GET_ME";


export const bookingOpen = (boolean) => {
  return (dispatch) => {
    return  dispatch({ type: OPEN_RESA, payload: boolean });
  };
}